<template>
    <div class="bg-white px-3 md:px-0">
        <div class="mx-auto pt-6 pb-6 w-[100%] sm:w-[90%] min-w-[290px] max-w-[1170px] flex items-center justify-between grid grid-cols-1 gap-2">
            <div class="flex justify-center mt-4">
                <h2 class="text-[26px] md:text-[38px] font-bold text-center">{{ $t('offer_v1.Going Solar as easy as 1-2-3') }}</h2>
            </div>
            <div class="flex justify-center pb-[45px]">
                <h3 class="text-[16px] md:text-[18px] text-[#959BB5] text-center">{{ $t('offer_v1.Our goal is to make going solar straightforward and transparent') }} </h3>
            </div>

            <div class="container mx-auto">
                <!-- Block 1: Image on the left on wide screens, above on mobile -->
                <div class="flex flex-col md:flex-row mb-4 gap-6">
                    <div class="md:w-1/4">
                        <img src="/img/offers_calc/Get_an_instant_quote.jpg" :alt="$t('offer_v1.Get an instant quote') " class="w-full">
                    </div>
                    <div class="md:w-3/4 md:pl-4 bg-[#F7F8FB] px-6 md:px-12 py-6 rounded-[12px]">
                        <h3 class="text-[20px] md:text-[28px] font-bold mb-2">
                            <span class="inline-flex justify-center items-center w-[24px] h-[24px] md:w-[30px] md:h-[30px] mr-2 bg-[#0676C2] text-white text-[14px] md:text-[18px] font-bold rounded-full">1</span>
                            {{ $t('offer_v1.Get an instant quote') }}
                        </h3>
                        <p class="mb-4 text-[14px] md:text-[16px] text-[#2C2C4F]">
                            {{ $t('offer_v1.Get an instant quote text') }}
                        </p>
                        <button @click="scrollToTop" class="bg-[#F6C407] text-[#2C2C4F] text-[15px] font-weight-bold py-3 px-6 rounded-lg">{{ $t('offer_v1.Get your quote') }}</button>
                    </div>

                </div>

                <!-- Block 2: Image on the right on wide screens, above on mobile -->
                <div class="flex flex-col md:flex-row-reverse mb-4 gap-6">
                    <div class="md:w-1/3">
                        <img src="/img/offers_calc/Meet_with_our_solar_experts.png" alt="Meet with our solar experts" class="w-full">
                    </div>
                    <div class="md:w-2/3 md:pr-4 bg-[#F7F8FB] px-6 md:px-12 py-6 rounded-[12px]">
                        <h3 class="text-[20px] md:text-[28px] font-bold mb-2">
                            <span class="inline-flex justify-center items-center w-[24px] h-[24px] md:w-[30px] md:h-[30px] mr-2 bg-[#0676C2] text-white text-[14px] md:text-[18px] font-bold rounded-full">2</span>
                            {{ $t('offer_v1.Meet with our solar experts') }}
                        </h3>
                        <p class="mb-4 text-[14px] md:text-[16px] text-[#2C2C4F]">
                            {{ $t('offer_v1.Meet with our solar experts text') }}
                        </p>
                        <button @click="scrollToTop" class="bg-[#F6C407] text-[#2C2C4F] text-[15px] font-weight-bold py-3 px-6 rounded-lg">{{ $t('offer_v1.Meet our experts') }}</button>
                    </div>
                </div>

                <!-- Block 3: Image on the left on wide screens, above on mobile -->
                <div class="flex flex-col md:flex-row mb-4 gap-6">
                    <div class="md:w-1/4">
                        <img src="/img/offers_calc/Professional_installation_within_4_weeks.jpg" alt="Professional installation within 4 weeks" class="w-full">
                    </div>
                    <div class="md:w-3/4 md:pl-4 bg-[#F7F8FB] px-6 md:px-12 py-6 rounded-[12px]">
                        <h3 class="text-[20px] md:text-[28px] font-bold mb-2">
                            <span class="inline-flex justify-center items-center w-[24px] h-[24px] md:w-[30px] md:h-[30px] mr-2 bg-[#0676C2] text-white text-[14px] md:text-[18px] font-bold rounded-full">3</span>
                            {{ $t('offer_v1.Professional installation within 4 weeks') }}
                        </h3>
                        <p class="mb-4 text-[14px] md:text-[16px] text-[#2C2C4F]">
                            {{ $t('offer_v1.Professional installation within 4 weeks text') }}
                        </p>
                        <button @click="scrollToTop" class="bg-[#F6C407] text-[#2C2C4F] text-[15px] font-weight-bold py-3 px-6 rounded-lg">{{ $t('offer_v1.I want solar panels') }}</button>
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-10 mx-5">
                <h2 class="text-[24px] md:text-[38px] font-bold text-center">{{ $t('offer_v1.Discover our range of  products') }}</h2>
            </div>
            <div class="flex justify-center pb-[45px] mx-5">
                <h3 class="text-[16px] md:text-[18px] text-[#959BB5] text-center">{{ $t('offer_v1.Our goal is to make going solar straightforward and transparent') }}</h3>
            </div>

            <div class="container mx-auto">
                <!-- Block 1: Image on the left on wide screens, above on mobile -->
                <div class="flex flex-col md:flex-row mb-4 gap-6">
                    <div class="md:w-1/2">
                        <img src="/img/offers_calc/Glass-glass_performance_panels.jpg" :alt="$t('offer_v1.Get an instant quote')" class="w-full">
                    </div>
                    <div class="md:w-1/2 md:pl-4 px-12 py-6 rounded-[12px]">
                        <h4 class="text-[18px] text-[#00A842]">{{ $t('offer_v1.The Solar Panels') }}</h4>
                        <h3 class="text-[28px] font-bold mb-2">{{ $t('offer_v1.The Solar Panels title') }}</h3>
                        <p class="mb-4 text-[16px] text-[#2C2C4F]">
                            {{ $t('offer_v1.The Solar Panels text') }}
                        </p>
                        <div class="mb-5 flex items-start">
                            <img src="/img/icons/icon_green_check.svg" class="w-[25px] h-[25px] mt-[2px] mr-2" alt="Info icon" />
                            <div class="flex-grow text-[16px] text-[#2C2C4F]">
                                <div class="font-weight-bold">{{ $t('offer_v1.The Solar Panels li1 title') }}</div>
                                <div>{{ $t('offer_v1.The Solar Panels li1 text') }}</div>
                            </div>
                        </div>
                        <div class="mb-5 flex items-start">
                            <img src="/img/icons/icon_green_check.svg" class="w-[25px] h-[25px] mt-[2px] mr-2" alt="Info icon" />
                            <div class="flex-grow text-[16px] text-[#2C2C4F]">
                                <div class="font-weight-bold">{{ $t('offer_v1.The Solar Panels li2 title') }}</div>
                                <div>{{ $t('offer_v1.The Solar Panels li2 text') }}</div>
                            </div>
                        </div>
                        <div class="mb-5 flex items-start">
                            <img src="/img/icons/icon_green_check.svg" class="w-[25px] h-[25px] mt-[2px] mr-2" alt="Info icon" />
                            <div class="flex-grow text-[16px] text-[#2C2C4F]">
                                <div class="font-weight-bold">{{ $t('offer_v1.The Solar Panels li3 title') }}</div>
                                <div>{{ $t('offer_v1.The Solar Panels li3 text') }}</div>
                            </div>
                        </div>
                        <button @click="scrollToTop" class="bg-[#F6C407] text-[#2C2C4F] text-[15px] font-weight-bold py-3 px-6 rounded-lg">{{ $t('offer_v1.The Solar Panels button') }}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="bg-[#F7F9FC] px-3 md:px-0">
        <div class="mx-auto pt-6 pb-6 w-[100%] sm:w-[90%] min-w-[290px] max-w-[1170px] flex items-center justify-between grid grid-cols-1 gap-2">
            <div class="container mx-auto">
                <!-- Block 1: Image on the left on wide screens, above on mobile -->
                <div class="flex flex-col md:flex-row-reverse mb-4 gap-6">
                    <div class="md:w-1/2 ml-[100px] mt-[50px]">
                        <img src="/img/offers_calc/inverter.png" alt="Get an instant quote" class="w-2/3">
                    </div>
                    <div class="md:w-1/2 md:pl-4 px-12 py-6 rounded-[12px]">
                        <h4 class="text-[18px] text-[#0676C2]">{{ $t('offer_v1.The inverter') }}</h4>
                        <h3 class="text-[28px] font-bold mb-2">{{ $t('offer_v1.The inverter title') }}</h3>
                        <p class="mb-4 text-[16px] text-[#2C2C4F]">
                            {{ $t('offer_v1.The inverter text') }}
                        </p>
                        <div class="mb-5 flex items-start">
                            <img src="/img/icons/icon_blue_check.svg" class="w-[25px] h-[25px] mt-[2px] mr-2" alt="Info icon" />
                            <div class="flex-grow text-[16px] text-[#2C2C4F]">
                                <div class="font-weight-bold">{{ $t('offer_v1.The inverter li1 title') }}</div>
                                <div>{{ $t('offer_v1.The inverter text') }}</div>
                            </div>
                        </div>
                        <div class="mb-5 flex items-start">
                            <img src="/img/icons/icon_blue_check.svg" class="w-[25px] h-[25px] mt-[2px] mr-2" alt="Info icon" />
                            <div class="flex-grow text-[16px] text-[#2C2C4F]">
                                <div class="font-weight-bold">{{ $t('offer_v1.The inverter li2 title') }}</div>
                                <div>{{ $t('offer_v1.The inverter li2 text') }}</div>
                            </div>
                        </div>
                        <button @click="scrollToTop" class="bg-[#F6C407] text-[#2C2C4F] text-[15px] font-weight-bold py-3 px-6 rounded-lg">{{ $t('offer_v1.The inverter button') }}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="bg-white px-3 md:px-0">
        <div class="mx-auto pt-6 pb-6 w-[100%] sm:w-[90%] min-w-[290px] max-w-[1170px] flex items-center justify-between grid grid-cols-1 gap-2">
            <div class="container mx-auto">
                <!-- Block 1: Image on the left on wide screens, above on mobile -->
                <div class="flex flex-col md:flex-row mb-4 gap-6">
                    <div class="md:w-1/2 ml-[100px] mt-[50px]">
                        <img src="/img/offers_calc/batt.png" :alt="$t('offer_v1.The battery title')" class="w-2/3">
                    </div>
                    <div class="md:w-1/2 md:pl-4 px-12 py-6 rounded-[12px]">
                        <h4 class="text-[18px] text-[#FAA51A]">{{ $t('offer_v1.The battery') }}</h4>
                        <h3 class="text-[28px] font-bold mb-2">{{ $t('offer_v1.The battery title') }}</h3>
                        <p class="mb-4 text-[16px] text-[#2C2C4F]">
                            {{ $t('offer_v1.The battery text') }}
                        </p>
                        <div class="mb-5 flex items-start">
                            <img src="/img/icons/icon_orange_check.svg" class="w-[25px] h-[25px] mt-[2px] mr-2" alt="Info icon" />
                            <div class="flex-grow text-[16px] text-[#2C2C4F]">
                                <div class="font-weight-bold">{{ $t('offer_v1.The battery li1 title') }}</div>
                                <div>{{ $t('offer_v1.The battery li1 text') }}</div>
                            </div>
                        </div>
                        <div class="mb-5 flex items-start">
                            <img src="/img/icons/icon_orange_check.svg" class="w-[25px] h-[25px] mt-[2px] mr-2" alt="Info icon" />
                            <div class="flex-grow text-[16px] text-[#2C2C4F]">
                                <div class="font-weight-bold">{{ $t('offer_v1.The battery li2 title') }}</div>
                                <div>{{ $t('offer_v1.The battery li2 text') }}</div>
                            </div>
                        </div>
                        <button @click="scrollToTop" class="bg-[#F6C407] text-[#2C2C4F] text-[15px] font-weight-bold py-3 px-6 rounded-lg">{{ $t('offer_v1.The battery button') }}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ref from "vue";
import config from "tailwindcss/defaultConfig";

export default {
    name: "SingleOfferInfoBlock",
    props: {

    },
    components: {
    },
    data() {
        return {

        };
    },
    mounted() {

    },
    computed: {

    },
    methods: {
        scrollToTop() {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        },
    },
};
</script>

<style scoped>

</style>
